import { Component } from '@angular/core'

/**
 * Tiny component to display a warning message for 'recommended' fields
 */
@Component({
  selector: 'app-required-field-text',
  template: `
    <div class="recommended-text" i18n="@@metadata-recommended-field">Recommended field</div>
  `,
})
export class RequiredFieldTextComponent {}
